import React from "react";
import { Viewer } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";
import addHttpsToAnchorTag from "utils/addHttpsToAnchorTag";

export interface DocumentDetailEditorViewerProps {
  contents: string;
}

const DocumentDetailEditorViewer = ({
  contents,
}: DocumentDetailEditorViewerProps) => {
  return <Viewer initialValue={addHttpsToAnchorTag(contents)} />;
};

export default DocumentDetailEditorViewer;
